import React from 'react';
import { Link } from 'react-router-dom';

const Research = () => {
    const achievementLinks = [

 {
            imgSrc: "/research/IEEE.png",
            link: "/achievements/achievement",
          //  title: "ML Fault Detection in Manufacturing"
        },


        {
            imgSrc: "/research/research.png",
            link: "https://github.com/Hazrat-Ali9",
           // title: "Edge Computing in Industrial Automation"
        },
        {
            imgSrc: "/research/google.png",
            link: "/achievements/blackbelt",
           // title: "Cybersecurity Challenges in ICS"
        },
        // {
        //     imgSrc: "/research/IEEE.png",
        //     link: "/achievements/achievement",
        //     title: "ML Fault Detection in Manufacturing"
        // },
        // {
        //     imgSrc: "/research/reseach4.jpg",
        //     link: "/achievements/webdevelopment",
        //     title: "Blockchain for Secure IoT Networks"
        // },
        {
            imgSrc: "/research/academia.png",
            link: "/achievements/python",
          //  title: "Digital Twins in Manufacturing"
        },
        {
            imgSrc: "/research/semanticscholar.png",
            link: "/achievements/java",
          //  title: "Soft Robotics Applications"
        },
    ];

    const getAnimationClass = (index) => {
        const animations = [
            'animate__fadeInDown',
            'animate__fadeInUp',
            'animate__fadeInRight',
            'animate__fadeInLeft'
        ];
        const delays = ['animate__delay-0.5s', 'animate__delay-1s'];

        return `animate__animated ${animations[index % animations.length]} ${delays[index % delays.length]}`;
    };

    return (
        <div className='min-h-[80vh] max-w-7xl mx-auto'>
            {/* Banner Section */}
            <div className="relative w-full h-[30vh] sm:h-[35vh] md:h-[40vh] lg:h-[45vh] overflow-hidden">
                <img
                    src="/research/banner.png"
                    alt="Research Papers Banner"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center p-4 text-center">
                    <h1 className='text-xl sm:text-3xl md:text-3xl lg:text-4xl font-bold text-white mb-2 sm:mb-3'>
                        Research Papers
                    </h1>
                    <p className="text-white text-xs sm:text-sm md:text-base max-w-md">
                        
                    </p>
                </div>
            </div>

            {/* Research Papers Grid - 4 columns */}
            <div className='py-6 sm:py-8 lg:py-10'>
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 lg:gap-6'>
                    {achievementLinks.map((item, index) => (
                        <div key={index} className={`${getAnimationClass(index)} aspect-[4/3] relative group`}>
                            <Link to={item.link} className="block h-full">
                                <img
                                    src={item.imgSrc}
                                    alt={item.title}
                                    className='w-full h-full object-cover group-hover:shadow-md transition-all duration-300 group-hover:opacity-90 group-hover:scale-[1.02]'
                                />
                                <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center p-3 text-center transition-all duration-300 group-hover:bg-black/50">
                                    <h3 className="text-white font-semibold text-base sm:text-lg md:text-xl px-2 leading-tight">
                                        {item.title}
                                    </h3>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Research;